import React from 'react';
import PropTypes from 'prop-types';
import { Label, StyledSwitch, SwitchBox, SwitchHandle, WrappingLabel } from './style';

function Switch({
  checked,
  className,
  disabled,
  leftLabel,
  rightLabel,
  size = 'medium',
  onChange
}) {
  return (
    <WrappingLabel className={className} disabled={disabled} size={size}>
      <StyledSwitch checked={checked} disabled={disabled} onChange={onChange} />
      {leftLabel && <Label>{leftLabel}</Label>}
      <SwitchBox>
        <SwitchHandle />
      </SwitchBox>
      {rightLabel && <Label checked={checked}> {rightLabel}</Label>}
    </WrappingLabel>
  );
}

Switch.displayName = 'Switch';

Switch.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
  size: PropTypes.oneOf(['medium']),
  onChange: PropTypes.func.isRequired
};

export default Switch;
